/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ character: NonNullable<unknown> }} Error_Nav_Illegal_CharactersInputs */



/**
* | output |
* | --- |
* | "Plain text contains illegal 608 characters: {character}" |
*
* @param {Error_Nav_Illegal_CharactersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_illegal_characters = /** @type {((inputs: Error_Nav_Illegal_CharactersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Illegal_CharactersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Le texte brut contient des caracteres 608 illegaux : ${i?.character}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Der Klartext enthält 608 ungültige Zeichen: ${i?.character}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Il testo normale contiene 608 caratteri illegali: ${i?.character}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`В открытом тексте содержится недопустимое количество символов (608): ${i?.character}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El texto sin formato contiene 608 caracteres ilegales: ${i?.character}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`纯文本包含 608 个非法字符：${i?.character}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プレーンテキストに不正な 608 文字が含まれています: ${i?.character}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`साधारण पाठ में 608 अवैध अक्षर हैं: ${i?.character}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`O texto simples contém 608 caracteres ilegais: ${i?.character}`)
	return /** @type {LocalizedString} */ (`Plain text contains illegal 608 characters: ${i?.character}`)
});